import type { OptimizationSearchProfile } from '../types/optimization'

export const DEFAULT_OPTIMIZATION_SEARCH_PROFILE: OptimizationSearchProfile = 'fast'

/** Database DECIMAL values can arrive as strings. Keep malformed values invalid. */
export function optionalConstraintNumber(value: unknown): number | undefined {
  if (value == null || (typeof value === 'string' && value.trim() === '')) return undefined
  if (typeof value !== 'number' && typeof value !== 'string') return NaN
  return Number(value)
}
